import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatStepperModule } from '@angular/material/stepper';

import { ApmTranslatePipe } from '@mitsubishi/core';
import { ButtonComponent, SectionTitleComponent, SelectModule } from '@mitsubishi/shared/ui';
import { AutocompleteComponent } from '@mitsubishi/ui/autocomplete';
import { UiDatepickerModule } from '@mitsubishi/ui/datepicker';
import { EditorComponent } from '@mitsubishi/ui/editor';
import { FileInputComponent } from '@mitsubishi/ui/file-input';

import { NewsAdminDialogCreationStepComponent } from './news-admin-dialog-creation-step/news-admin-dialog-creation-step.component';
import { NewsAdminDialogTagStepComponent } from './news-admin-dialog-tag-step/news-admin-dialog-tag-step.component';
import { NewsAdminDialogVisibilityStepComponent } from './news-admin-dialog-visibility-step/news-admin-dialog-visibility-step.component';
import { NewsAdminDialogComponent } from './news-admin-dialog.component';

@NgModule({
  imports: [
    CommonModule,

    MatStepperModule,
    ReactiveFormsModule,
    AutocompleteComponent,
    EditorComponent,
    UiDatepickerModule,
    SectionTitleComponent,
    FileInputComponent,
    ApmTranslatePipe,
    ButtonComponent,
    SelectModule,
  ],
  declarations: [
    NewsAdminDialogComponent,
    NewsAdminDialogCreationStepComponent,
    NewsAdminDialogTagStepComponent,
    NewsAdminDialogVisibilityStepComponent,
  ],
  exports: [],
})
class NewsAdminDialogModule {}
